export const COUNTRY_CODES = [
  { value: '', label: 'Country code' },
  { value: '+370', label: 'LT (+370)' },
  { value: '+1', label: 'US / CA (+1)' },
  { value: '+44', label: 'UK (+44)' },
  { value: '+49', label: 'DE (+49)' },
  { value: '+48', label: 'PL (+48)' },
  { value: '+371', label: 'LV (+371)' },
  { value: '+372', label: 'EE (+372)' },
  { value: '+33', label: 'FR (+33)' },
  { value: '+39', label: 'IT (+39)' },
  { value: '+34', label: 'ES (+34)' },
  { value: '+31', label: 'NL (+31)' },
  { value: '+46', label: 'SE (+46)' },
  { value: '+47', label: 'NO (+47)' },
  { value: '+45', label: 'DK (+45)' },
  { value: '+358', label: 'FI (+358)' },
  { value: '+61', label: 'AU (+61)' },
  { value: '+81', label: 'JP (+81)' },
  { value: '+86', label: 'CN (+86)' },
  { value: '+91', label: 'IN (+91)' },
];
